// src/components/Footer.js
import React from 'react';

const Footer = () => (
  <footer>
    <p>&copy; 2024 Independent Realty Group House Listings. All rights reserved.</p>
  </footer>
);

export default Footer;
